<template>
  <hm-content class="micro-goods-list">
    <div class="mb20 flex flex-between">
      <div>
        <el-radio-group
          v-model="searchCondition.timeStatus"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="daipeihuo"
            >待配货({{ invoiceList.number.no_delivery }})</el-radio-button
          >
          <el-radio-button label="daifahuo"
            >待发货({{ invoiceList.number.no_express }})</el-radio-button
          >
          <el-radio-button label="yifahuo"
            >已发货({{ invoiceList.number.is_express }})</el-radio-button
          >
        </el-radio-group>
      </div>
    </div>
    <div class="table-panel flex flex-between">
      <div class="mr10 flex item-center">
        <!-- <el-button type="primary" size="small">发货单模板设置</el-button> -->
        <el-radio-group v-model="isFahuodan" size="small">
          <el-tooltip
            effect="dark"
            content="竖版发货单为小票模板"
            placement="bottom"
          >
            <el-radio label="1">打印竖版发货单模板</el-radio>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            content="横板发货单为A4模板"
            placement="bottom"
          >
            <el-radio label="0">打印横板发货单模板(A4)</el-radio>
          </el-tooltip>
        </el-radio-group>
      </div>

      <!-- <div class="mr10" v-if="searchCondition.timeStatus === 'daifahuo'">
        <el-button type="primary" @click="batchFaHuo" size="small"
          >批量发货</el-button
        >
      </div> -->
      <div class="flex-1 text-right">
        <el-input
          clearable
          v-model.trim="searchCondition.keyword"
          placeholder="请输入下单/收货手机号"
          size="small"
          style="width:220px;"
          class="mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.queryKey"
          placeholder="请输入订单号/发货单号/提货码"
          size="small"
          style="width:270px;"
          class="mr10"
        ></el-input>
        <el-select
          clearable
          size="small"
          filterable
          class="mr10"
          v-model="searchCondition.belongShopId"
          placeholder="请选择所属门店"
        >
          <el-option
            v-for="(item, i) in expressShopList"
            :key="i"
            :label="item.shopName"
            :value="item.shopId"
          >
          </el-option>
        </el-select>
        <!-- <el-input
          clearable
          v-model.trim="searchCondition.deliverSn"
          placeholder="请输入发货单号"
          size="small"
          class="mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.expressOrderSn"
          placeholder="请输入快递单号"
          size="small"
          class="mr10"
        ></el-input> -->
        <el-select
          clearable
          v-model="searchCondition.deliveryType"
          placeholder="选择配送方式"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="门店自提" value="mdzt"></el-option>
          <el-option label="快递发货" value="kdfh"></el-option>
          <el-option label="同城配送" value="tcps"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="flex batch flex-between">
        <div
          class="flex flex-center item-center"
          v-if="searchCondition.timeStatus === 'daipeihuo'"
        >
          <span>已选{{ num }}条</span>
        </div>
        <div v-if="searchCondition.timeStatus === 'daipeihuo'">
          <!-- <span @click="batchScan" class="pointer mr10">
            <span class="delete-icon hmicon icon-cuxiaoguanli"></span>
            批量扫描快递单
          </span> -->

          <span @click="batchFaHuoDan" class="pointer mr10">
            <span class="delete-icon hmicon icon-cuxiaoguanli"></span>
            批量打印发货单
          </span>
          <span @click="batchSetting" class="pointer">
            <span class="delete-icon hmicon icon-cuxiaoguanli"></span>
            批量打印快递单
          </span>
        </div>
        <div class="mr10" v-if="searchCondition.timeStatus === 'daifahuo'">
          <el-button type="primary" @click="batchFaHuo" size="small"
            >去发货</el-button
          >
        </div>
      </div>

      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="invoiceList.order.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="selection"
          v-if="searchCondition.timeStatus === 'daipeihuo'"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="订单号"
        >
          <template slot-scope="scope">
            <div class="blue pointer" @click="details(scope.row)">
              {{ scope.row.receiptSn }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliveryType"
          label="配送方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.deliveryType === 'mdzt'">门店自提</span>
            <span v-if="scope.row.deliveryType === 'kdfh'">快递发货</span>
            <span v-if="scope.row.deliveryType === 'tcps'">同城配送</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="发货门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusTime"
          label="发货时间"
          v-if="searchCondition.timeStatus === 'yifahuo'"
        ></el-table-column>
        <el-table-column
          v-else
          header-align="center"
          align="center"
          prop="purchaseTime"
          label="下单时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliverSn"
          label="发货单号"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="expressOrderSn"
          label="快递单号"
        >
          <template slot-scope="scope" v-if="scope.row.deliveryType === 'kdfh'">
            <span v-if="searchCondition.timeStatus === 'yifahuo'">{{
              scope.row.expressOrderSn
            }}</span>
            <el-input
              v-else
              :disabled="scope.row.disabled"
              @keyup.enter.native="submitOrderSn(scope.row)"
              v-model="scope.row.expressOrderSn"
              clearable
              style="width:150px;"
              placeholder="请扫描快递单号"
              size="small"
              class="ipt mr10"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="orderState"
          label="当前状态"
          v-if="searchCondition.timeStatus === 'yifahuo'"
        >
          <template slot-scope="scope">
            <span
              class="status blue"
              v-if="scope.row.orderStatus === 'deliverOrder'"
              >{{
                scope.row.deliveryType === "mdzt"
                  ? "等待门店自提"
                  : "等待确认收货"
              }}</span
            >
            <span
              class="status blue"
              v-if="scope.row.orderStatus === 'takeOrder'"
              >{{
                scope.row.deliveryType === "mdzt" ? "已提货" : "已确认收货"
              }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="250px"
          v-else
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <div v-if="searchCondition.timeStatus === 'daipeihuo'">
                <el-button
                  size="small"
                  type="text"
                  @click="scan(scope.row)"
                  :disabled="!!scope.row.expressOrderSn"
                  v-if="scope.row.deliveryType === 'kdfh' && scope.row.disabled"
                  >扫描快递单</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="submitOrderSn(scope.row)"
                  v-if="
                    scope.row.deliveryType === 'kdfh' && !scope.row.disabled
                  "
                  >确认快递单</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="printInvoice(scope.row)"
                  >打印发货单</el-button
                >

                <el-button
                  size="small"
                  type="text"
                  v-if="scope.row.deliveryType === 'kdfh'"
                  :disabled="!!scope.row.expressOrderSn"
                  @click="printCourierReceipt(scope.row)"
                  >打印快递单</el-button
                >
              </div>
              <div v-if="searchCondition.timeStatus === 'daifahuo'">
                <el-button
                  size="small"
                  type="text"
                  @click="printCourierReceipt(scope.row)"
                  v-if="scope.row.deliveryType === 'kdfh'"
                  >补打快递单</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="printInvoice(scope.row)"
                  >补打发货单</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="scan(scope.row)"
                  v-if="scope.row.deliveryType === 'kdfh'"
                  >重扫快递单</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="invoiceList.order.total"
        @current-change="paging"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      width="720px"
      title="订单详情"
      v-if="isFahuodan === '0'"
    >
      <div class="content">
        <div class="flex flex-end" style="padding-right:20px;padding-top:10px;">
          <div>
            <!-- <el-button
              type="primary"
              size="small"
              @click="printTe"
              v-print="'#printTest'"
              >打印</el-button
            > -->
            <el-button type="primary" size="small" @click="printTe"
              >打印</el-button
            >
          </div>
        </div>
        <div>
          <ul class="info-list" ref="print" id="printTest">
            <li class="mb10">
              <div class="flex flex-between tit">
                <div class="flex-1 flex flex-warp">
                  <div
                    class="logoImg"
                    style="width:92px;height:92px;paddingRight:20px;"
                  >
                    <img
                      style="width:100px;height:100%"
                      :src="querySupplier.logoPath"
                      alt=""
                    />
                  </div>
                  <!-- <div class="hr"></div> -->
                  <div class="sh-info ml20">
                    <div class="sh-name">
                      {{ querySupplier.storeName }}
                    </div>
                    <div class="sh-xinxi">
                      {{ querySupplier.storeAddress }}
                    </div>
                    <div class="sh-xinxi">
                      电话：{{ querySupplier.contactPhone }}
                    </div>
                  </div>
                </div>
                <vue-barcode
                  :value="newDetailsOrder.order.receiptSn.slice(2)"
                  :options="barcode_option"
                  tag="svg"
                ></vue-barcode>
              </div>
            </li>
            <li class="mb20">
              <div class="consignee">
                <div style="fontWeight: 700" class="primary">
                  流水号:{{ newDetailsOrder.order.serialNumber }}
                </div>
                <div
                  style="fontWeight: 700"
                  v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                >
                  配送方式:门店自提
                </div>
                <div
                  style="fontWeight: 700"
                  v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                >
                  配送方式:快递发货
                </div>
                <div
                  style="fontWeight: 700"
                  v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                >
                  配送方式:同城配送
                </div>
                <div>订单编号：{{ newDetailsOrder.order.receiptSn }}</div>
                <div style="fontWeight: 600">收货人信息</div>
                <div>收货人：{{ newDetailsOrder.order.receiverName }}</div>
                <div>手机号码：{{ newDetailsOrder.order.receiverMobile }}</div>
                <div>邮政编码：{{ newDetailsOrder.order.spuName }}</div>
                <div>
                  收货地址：{{ newDetailsOrder.order.deliveryProvince
                  }}{{ newDetailsOrder.order.deliveryAddress }}
                </div>
              </div>
              <div class="consignee">
                <div>下单时间：{{ newDetailsOrder.order.purchaseTime }}</div>
                <div>支付时间：{{ newDetailsOrder.order.payTime }}</div>
                <div>
                  支付方式：
                  <span
                    class="primary"
                    v-if="newDetailsOrder.order.payMode === 'no_pay'"
                    >未支付</span
                  >
                  <span
                    class="primary"
                    v-if="newDetailsOrder.order.payMode === '0_pay'"
                    >0元订单</span
                  >
                  <span
                    class="primary"
                    v-if="newDetailsOrder.order.payMode === 'wx_pay'"
                    >微信支付</span
                  >
                </div>
              </div>
            </li>
            <li class="mb20">
              <!-- <el-table
                :data="detailsOrder.orderGoods"
                size="small"
                style="width:100%"
                :header-cell-style="{background:'#F7F7F7',color:'#606266'}"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="商品名称/品牌"
                >
                  <template slot-scope="scope">
                    <p>{{ scope.row.spuName }}</p>
                    <p>品牌: {{ scope.row.brandName }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="价格/货号"
                >
                  <template slot-scope="scope">
                    <p>价格: {{ scope.row.totalPrice }}</p>
                    <p>货号: {{ scope.row.goodsSn }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="净重/毛重"
                >
                  <template slot-scope="scope">
                    <p v-if="scope.row.netWeight">
                      净重: {{ scope.row.netWeight }}
                    </p>
                    <p v-if="scope.row.grossWeight">
                      毛重: {{ scope.row.grossWeight }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop=""
                  label="规格"
                >
                  --
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNum"
                  label="数量"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="小计"
                >
                  <template slot-scope="scope">
                    <p>
                      {{ scope.row.totalPrice * scope.row.goodsNum }}
                    </p>
                  </template>
                </el-table-column>
              </el-table> -->
              <div class="modal-table">
                <div class="table-header flex">
                  <div class="flex-1 flex flex-center">商品名称/品牌</div>
                  <div class="flex-1 flex flex-center">价格/货号</div>
                  <div class="flex-1 flex flex-center">净重/毛重</div>
                  <div class="flex-1 flex flex-center">
                    规格
                  </div>
                  <div class="flex-1 flex flex-center">
                    数量
                  </div>
                  <div class="flex-1 flex flex-center">
                    小计
                  </div>
                </div>
                <div
                  class="table-body flex"
                  :class="{ tuikuan: v.returnType !== 'no' }"
                  v-for="(v, i) in newDetailsOrder.orderGoods"
                  :key="i"
                >
                  <img
                    class="warning-tuikuan"
                    v-show="v.returnType === 'yes'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                    alt=""
                  />
                  <img
                    class="warning-tuikuan"
                    v-show="v.returnType === 'doing'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                    alt=""
                  />
                  <div class="flex-1 flex flex-center flex-column">
                    <div>
                      <p>{{ v.spuName }}</p>
                      <p>品牌: {{ v.brandName }}</p>
                    </div>
                  </div>
                  <div class="flex-1 flex flex-center flex-column">
                    <div>
                      <p>价格: {{ v.totalPrice }}</p>
                      <p>货号: {{ v.goodsSn }}</p>
                      <p>条码: {{ v.barCode }}</p>
                    </div>
                  </div>
                  <div class="flex-1 flex flex-center flex-column">
                    <div>
                      <p v-if="v.netWeight">净重: {{ v.netWeight }}</p>
                      <p v-if="v.grossWeight">毛重: {{ v.grossWeight }}</p>
                    </div>
                  </div>
                  <div class="flex-1 flex flex-center flex-column">
                    {{ v.specIdGroupName }}
                  </div>
                  <div class="flex-1 flex flex-center flex-column">
                    {{ v.goodsNum }}
                  </div>
                  <div class="flex-1 flex flex-center flex-column">
                    {{ v.totalPrice * v.goodsNum }}
                  </div>
                </div>
              </div>
            </li>
            <li class="mb20">
              <!-- <el-table stripe :header-cell-style="{background:'#F7F7F7',color:'#606266'}"  :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="商品合计"
                >
                  <template slot-scope="scope">
                    <p>{{ scope.row.totalPrice }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="运费"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="couponMoney"
                  label="优惠券"
                >
                  <template slot-scope="scope">
                    <span class="status danger"
                      >-￥{{ scope.row.couponMoney }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="积分抵扣"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="activeMoney"
                  label="活动优惠"
                >
                  <template slot-scope="scope">
                    <span class="status danger"
                      >-￥{{ scope.row.activeMoney }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="actuallyPrice"
                  label="实付金额"
                >
                  <template slot-scope="scope">
                    <span class="status danger"
                      >￥{{ scope.row.actuallyPrice }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="payPrice"
                  label="应付金额"
                >
                  <template slot-scope="scope">
                    <span class="status danger"
                      >￥{{ scope.row.payPrice }}</span
                    >
                  </template>
                </el-table-column>
              </el-table> -->
              <div class="modal-table">
                <div class="table-header flex">
                  <div class="flex-1 flex flex-center">商品合计</div>
                  <div class="flex-1 flex flex-center">运费</div>
                  <div class="flex-1 flex flex-center">优惠券</div>
                  <div class="flex-1 flex flex-center">
                    积分抵扣
                  </div>
                  <div class="flex-1 flex flex-center">
                    活动优惠
                  </div>
                  <div class="flex-1 flex flex-center">
                    实付金额
                  </div>
                  <div class="flex-1 flex flex-center">
                    应付金额
                  </div>
                </div>
                <div class="table-body flex">
                  <div class="flex-1 flex flex-center">
                    ￥{{ newDetailsOrder.order.totalPrice }}
                  </div>
                  <div class="flex-1 flex flex-center">
                    {{ newDetailsOrder.order.deliverMoney }}
                  </div>
                  <div class="flex-1 flex flex-center status danger">
                    -￥{{ newDetailsOrder.order.couponMoney }}
                  </div>
                  <div class="flex-1 flex flex-center">
                    {{ newDetailsOrder.order.spuName }}
                  </div>
                  <div class="flex-1 flex flex-center status danger">
                    -￥{{ newDetailsOrder.order.activeMoney }}
                  </div>
                  <div class="flex-1 flex flex-center status danger">
                    ￥{{ newDetailsOrder.order.actuallyPrice }}
                  </div>
                  <div class="flex-1 flex flex-center status danger">
                    ￥{{ newDetailsOrder.order.payPrice }}
                  </div>
                </div>
              </div>
              <div class="mt10 consignee" style="lineHeight: 30px;">
                备注：
                <span style="fontSize:30px">{{
                  newDetailsOrder.order.orderRemark
                }}</span>
              </div>
            </li>
            <li class="mb30 ml10">
              <div class="mb20">
                制单人：_________ 配货人：_________ 验货人：_________
                收银员：_________
              </div>
              <div class="mb10">
                录单人：_________ 送货人：_________ 顾客：_________
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span> -->
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      width="200px"
      v-if="isFahuodan === '1'"
    >
      <div slot="title">
        <span class="mr10">订单详情</span>
      </div>
      <div class="content">
        <div class="flex flex-end p20">
          <div>
            <!-- <el-button
              type="primary"
              size="small"
              @click="printTe"
              v-print="'#printTest'"
              >打印</el-button
            > -->
            <el-button type="primary" size="small" @click="printTe"
              >打印</el-button
            >
          </div>
        </div>
        <div>
          <ul class="info-list" ref="print" id="printTest">
            <li>
              <div class="flex flex-center">
                <vue-barcode
                  :value="newDetailsOrder.order.receiptSn.slice(2)"
                  :options="barcode_options"
                  tag="svg"
                ></vue-barcode>
              </div>
            </li>
            <li class="mb20">
              <div class="title">基本信息</div>

              <div class="mb20">
                <div style="fontWeight: 700" class="fz mb10 primary">
                  流水号:{{ newDetailsOrder.order.serialNumber }}
                </div>
                <div class="fz mb10">
                  订单号：{{ newDetailsOrder.order.receiptSn }}
                </div>
                <div class="fz mb10">
                  购物人：{{ newDetailsOrder.order.receiverName }}
                </div>
                <div
                  class="fz mb10"
                  v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                >
                  配送方式：门店自提
                </div>
                <div
                  class="fz mb10"
                  v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                >
                  配送方式：快递发货
                </div>
                <div
                  class="fz mb10"
                  v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                >
                  配送方式：同城配送
                </div>

                <div class="fz mb10">
                  付款时间：{{ newDetailsOrder.order.payTime }}
                </div>
                <div class="fz mb10">
                  付款方式：微信支付
                </div>
                <div class="fz mb10">
                  商城门店：{{ newDetailsOrder.order.shopName }}
                </div>
                <div class="fz mb10">
                  收货地址：{{ newDetailsOrder.order.deliveryProvince
                  }}{{ newDetailsOrder.order.deliveryAddress }}
                </div>
              </div>
            </li>
            <li class="mb20">
              <div class="title">商品信息</div>
              <div
                class="fz mb30"
                v-for="(v, i) in newDetailsOrder.orderGoods"
                :class="{ wrongs: v.returnType !== 'no' }"
                :key="i"
              >
                <div>
                  <img
                    v-show="v.returnType === 'yes'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                    alt=""
                  />
                  <img
                    v-show="v.returnType === 'doing'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                    alt=""
                  />
                </div>
                <div class="mb5">
                  <p class="mb5">商品名称:{{ v.spuName }}</p>
                </div>
                <p class="mb5">品牌:{{ v.brandName }}</p>
                <p class="mb5">规格:{{ v.specIdGroupName }}</p>
                <p class="mb5">条码: {{ v.barCode }}</p>
                <p class="mb5">数量:{{ v.goodsNum }}</p>
                <p class="mb5">原价:{{ v.totalPrice }}</p>
                <p class="mb5">实付:{{ v.payPrice }}</p>
              </div>
              <hr />
              <div class="fz mb20">
                配送费：{{ newDetailsOrder.order.deliverMoney }}
              </div>
              <div class="fz mb20">
                优惠券：{{ newDetailsOrder.order.couponMoney }}
              </div>
              <div class="fz mb20">
                合计：{{ newDetailsOrder.order.payPrice }}
              </div>
            </li>
            <li v-if="newDetailsOrder.order.orderRemark">
              <div class="title">备注</div>
              <div style="fontSize:20px;">
                备注：{{ newDetailsOrder.order.orderRemark }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span> -->
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      title="批量发货"
      :visible.sync="isShow"
      width="720px"
      v-if="isFahuodan === '0'"
    >
      <div class="flex flex-end p20">
        <div>
          <!-- <el-button
            type="primary"
            size="small"
            v-print="'#batchPrint'"
            @click="printTe"
            >批量打印</el-button
          > -->
          <el-button type="primary" size="small" @click="printTe"
            >批量打印</el-button
          >
        </div>
      </div>
      <div v-if="isFahuodan === '0'" id="batchPrint" ref="print" class="mb20">
        <div
          class="content"
          v-for="(newDetailsOrder, i) in orderList"
          :key="i"
          style="page-break-after:always"
        >
          <div>
            <ul class="info-list" id="printTest">
              <li class="mb10">
                <div class="flex flex-between tit">
                  <div class="flex flex-warp">
                    <div class="logoImg">
                      <img :src="querySupplier.logoPath" alt="" />
                    </div>
                    <!-- <div class="hr"></div> -->
                    <div class="sh-info ml20">
                      <div class="sh-name">
                        {{ querySupplier.storeName }}
                      </div>
                      <div class="sh-xinxi">
                        {{ querySupplier.storeAddress }}
                      </div>
                      <div class="sh-xinxi">
                        电话：{{ querySupplier.contactPhone }}
                      </div>
                    </div>
                  </div>
                  <vue-barcode
                    :value="newDetailsOrder.order.receiptSn.slice(2)"
                    :options="barcode_option"
                    tag="svg"
                  ></vue-barcode>
                </div>
              </li>
              <li class="mb20">
                <div class="consignee">
                  <div style="fontWeight: 700" class="primary">
                    流水号:{{ newDetailsOrder.order.serialNumber }}
                  </div>
                  <div
                    style="fontWeight: 700"
                    v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                  >
                    配送方式:门店自提
                  </div>
                  <div
                    style="fontWeight: 700"
                    v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                  >
                    配送方式:快递发货
                  </div>
                  <div
                    style="fontWeight: 700"
                    v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                  >
                    配送方式:同城配送
                  </div>
                  <div>订单编号：{{ newDetailsOrder.order.receiptSn }}</div>
                  <div style="fontWeight: 600">收货人信息</div>
                  <div>收货人：{{ newDetailsOrder.order.receiverName }}</div>
                  <div>
                    手机号码：{{ newDetailsOrder.order.receiverMobile }}
                  </div>
                  <div>邮政编码：{{ newDetailsOrder.order.spuName }}</div>
                  <div>
                    收货地址：{{ newDetailsOrder.order.deliveryProvince
                    }}{{ newDetailsOrder.order.deliveryAddress }}
                  </div>
                </div>
                <div class="consignee">
                  <div>下单时间：{{ newDetailsOrder.order.purchaseTime }}</div>
                  <div>支付时间：{{ newDetailsOrder.order.payTime }}</div>
                  <div>
                    支付方式：
                    <span
                      class="primary"
                      v-if="newDetailsOrder.order.payMode === 'no_pay'"
                      >未支付</span
                    >
                    <span
                      class="primary"
                      v-if="newDetailsOrder.order.payMode === '0_pay'"
                      >0元订单</span
                    >
                    <span
                      class="primary"
                      v-if="newDetailsOrder.order.payMode === 'wx_pay'"
                      >微信支付</span
                    >
                  </div>
                </div>
              </li>
              <li class="mb20">
                <div class="modal-table">
                  <div class="table-header flex">
                    <div class="flex-1 flex flex-center">商品名称/品牌</div>
                    <div class="flex-1 flex flex-center">价格/货号</div>
                    <div class="flex-1 flex flex-center">净重/毛重</div>
                    <div class="flex-1 flex flex-center">
                      规格
                    </div>
                    <div class="flex-1 flex flex-center">
                      数量
                    </div>
                    <div class="flex-1 flex flex-center">
                      小计
                    </div>
                  </div>
                  <div
                    class="table-body flex"
                    :class="{ tuikuan: v.returnType !== 'no' }"
                    v-for="(v, i) in newDetailsOrder.orderGoods"
                    :key="i"
                  >
                    <!-- <img
                      class="warning-tuikuan"
                      v-show="v.returnType !== 'no'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                      alt=""
                    /> -->
                    <img
                      class="warning-tuikuan"
                      v-show="v.returnType === 'yes'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                      alt=""
                    />
                    <img
                      class="warning-tuikuan"
                      v-show="v.returnType === 'doing'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                      alt=""
                    />
                    <div class="flex-1 flex flex-center flex-column">
                      <div>
                        <p>{{ v.spuName }}</p>
                        <p>品牌: {{ v.brandName }}</p>
                      </div>
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      <div>
                        <p>价格: {{ v.totalPrice }}</p>
                        <p>货号: {{ v.goodsSn }}</p>
                        <p>条码: {{ v.barCode }}</p>
                      </div>
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      <div>
                        <p v-if="v.netWeight">净重: {{ v.netWeight }}</p>
                        <p v-if="v.grossWeight">毛重: {{ v.grossWeight }}</p>
                      </div>
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      {{ v.specIdGroupName }}
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      {{ v.goodsNum }}
                    </div>
                    <div class="flex-1 flex flex-center flex-column">
                      {{ v.totalPrice * v.goodsNum }}
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb20">
                <div class="modal-table">
                  <div class="table-header flex">
                    <div class="flex-1 flex flex-center">商品合计</div>
                    <div class="flex-1 flex flex-center">运费</div>
                    <div class="flex-1 flex flex-center">优惠券</div>
                    <div class="flex-1 flex flex-center">
                      积分抵扣
                    </div>
                    <div class="flex-1 flex flex-center">
                      活动优惠
                    </div>
                    <div class="flex-1 flex flex-center">
                      实付金额
                    </div>
                    <div class="flex-1 flex flex-center">
                      应付金额
                    </div>
                  </div>
                  <div class="table-body flex">
                    <div class="flex-1 flex flex-center">
                      ￥{{ newDetailsOrder.order.totalPrice }}
                    </div>
                    <div class="flex-1 flex flex-center">
                      {{ newDetailsOrder.order.deliverMoney }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      -￥{{ newDetailsOrder.order.couponMoney }}
                    </div>
                    <div class="flex-1 flex flex-center">
                      {{ newDetailsOrder.order.spuName }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      -￥{{ newDetailsOrder.order.activeMoney }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      ￥{{ newDetailsOrder.order.actuallyPrice }}
                    </div>
                    <div class="flex-1 flex flex-center status danger">
                      ￥{{ newDetailsOrder.order.payPrice }}
                    </div>
                  </div>
                </div>
                <div class="mt10 consignee" style="lineHeight: 30px;">
                  备注：
                  <span style="fontSize:30px">{{
                    newDetailsOrder.order.orderRemark
                  }}</span>
                </div>
              </li>
              <li class="mb30 ml10">
                <div class="mb20">
                  制单人：_________ 配货人：_________ 验货人：_________
                  收银员：_________
                </div>
                <div class="mb10">
                  录单人：_________ 送货人：_________ 顾客：_________
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      title="批量发货"
      :visible.sync="isShow"
      width="200px"
      v-if="isFahuodan === '1'"
    >
      <div class="flex flex-end p20">
        <div>
          <!-- <el-button
            type="primary"
            size="small"
            v-print="'#batchPrint'"
            @click="printTe"
            >批量打印</el-button
          > -->
          <el-button type="primary" size="small" @click="printTe"
            >批量打印</el-button
          >
        </div>
      </div>

      <div v-if="isFahuodan === '1'" ref="print" class="mb20">
        <div
          v-for="(newDetailsOrder, i) in orderList"
          :key="i"
          style="page-break-after:always"
        >
          <ul class="info-list" ref="print" id="printTest">
            <li>
              <div class="flex flex-center">
                <vue-barcode
                  :value="newDetailsOrder.order.receiptSn.slice(2)"
                  :options="barcode_options"
                  tag="svg"
                ></vue-barcode>
              </div>
            </li>
            <li class="mb20">
              <div class="title">基本信息</div>

              <div class="mb20">
                <div style="fontWeight: 700" class="fz mb10 primary">
                  流水号:{{ newDetailsOrder.order.serialNumber }}
                </div>
                <div class="fz mb10">
                  购物人：{{ newDetailsOrder.order.receiverName }}
                </div>
                <div
                  class="fz mb10"
                  v-if="newDetailsOrder.order.deliveryType === 'mdzt'"
                >
                  配送方式：门店自提
                </div>
                <div
                  class="fz mb10"
                  v-if="newDetailsOrder.order.deliveryType === 'kdfh'"
                >
                  配送方式：快递发货
                </div>
                <div
                  class="fz mb10"
                  v-if="newDetailsOrder.order.deliveryType === 'tcps'"
                >
                  配送方式：同城配送
                </div>

                <div class="fz mb10">
                  付款时间：{{ newDetailsOrder.order.payTime }}
                </div>
                <div class="fz mb10">
                  付款方式：微信支付
                </div>
                <div class="fz mb10">
                  商城门店：{{ newDetailsOrder.order.shopName }}
                </div>
                <div class="fz mb10">
                  收货地址：{{ newDetailsOrder.order.deliveryProvince
                  }}{{ newDetailsOrder.order.deliveryAddress }}
                </div>
              </div>
            </li>
            <li class="mb20">
              <div class="title">商品信息</div>
              <div
                class="fz mb30"
                v-for="(v, i) in newDetailsOrder.orderGoods"
                :class="{ wrongs: v.returnType !== 'no' }"
                :key="i"
              >
                <div>
                  <img
                    v-show="v.returnType === 'yes'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                    alt=""
                  />
                  <img
                    v-show="v.returnType === 'doing'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                    alt=""
                  />
                </div>
                <div class="mb5">
                  <p class="mb5">商品名称:{{ v.spuName }}</p>
                </div>
                <p class="mb5">品牌:{{ v.brandName }}</p>
                <p class="mb5">规格:{{ v.specIdGroupName }}</p>
                <p class="mb5">条码: {{ v.barCode }}</p>
                <p class="mb5">数量:{{ v.goodsNum }}</p>
                <p class="mb5">原价:{{ v.totalPrice }}</p>
                <p class="mb5">实付:{{ v.payPrice }}</p>
              </div>
              <hr />
              <div class="fz mb20">
                配送费：{{ newDetailsOrder.order.deliverMoney }}
              </div>
              <div class="fz mb20">
                优惠券：{{ newDetailsOrder.order.couponMoney }}
              </div>
              <div class="fz mb20">
                合计：{{ newDetailsOrder.order.payPrice }}
              </div>
            </li>
            <li v-if="newDetailsOrder.order.orderRemark">
              <div class="title">备注</div>
              <div style="fontSize:20px;">
                备注：{{ newDetailsOrder.order.orderRemark }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      title="批量发货"
      :visible.sync="isShowFaHuo"
      width="60%"
    >
      <div style="padding: 0 20px;">
        <div class="flex flex-center mb20" style="fontSize:20px">
          请使用扫码枪扫描发货单号/快递单号/提货码
        </div>
        <div class="flex flex-between mb20">
          <div style="fontSize:18px">需发货数量:{{ noNum }}</div>
          <div style="fontSize:18px">已扫描发货:{{ yesNum }}</div>
        </div>
        <div style="fontSize:18px">
          发货扫描:
          <el-input
            clearable
            v-model="isDeliverSn"
            size="small"
            ref="deliverSn"
            class="ipt mr10"
            style="width:250px"
            placeholder="请扫描/输入发货单号/快递单号/提货码"
            @keyup.enter.native="submit()"
          ></el-input>
          <el-button type="primary" size="small" @click="submit"
            >确认发货</el-button
          >
        </div>
        <div class="primary mt10" style="marginLeft:81px;">
          手动输入请按确认发货按钮或回车键发货
        </div>
        <div class="flex flex-center mt20">
          <el-button type="primary" size="small" @click="tingZhi"
            >停止批量发货</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="isKuaiDiDan"
      title="缺少快递单"
      width="40%"
    >
      <div style="padding: 0 20px;">
        <div class="flex flex-center mb20" style="fontSize:20px">
          该订单缺少快递单，请扫描或手输快递单后发货。
        </div>
        <!-- <div class="flex flex-between mb20">
          <div style="fontSize:18px">需发货数量:{{ noNum }}</div>
          <div style="fontSize:18px">已扫描发货:{{ yesNum }}</div>
        </div> -->
        <div style="fontSize:18px">
          发货扫描:
          <el-input
            clearable
            autofocus="autofocus"
            v-model="expressOrderSn"
            ref="express"
            size="small"
            class="ipt mr10"
            style="width:250px"
            placeholder="请扫描/输入快递单号"
            @keyup.enter.native="submitExpress()"
          ></el-input>
        </div>
        <div class="primary mt10" style="marginLeft:81px;">
          扫描快递单后自动发货，手输快递单号后请按确认发货按钮完成发货。
        </div>
        <div class="flex flex-center mt20">
          <el-button type="primary" size="small" @click="submitExpress"
            >确认发货</el-button
          >
          <el-button type="primary" size="small" @click="isKuaiDiDan = false"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetails">
      <div slot="title">
        <span class="mr10">订单详情</span>
      </div>
      <div class="content">
        <ul class="info-list">
          <li class="mb20">
            <div class="title">基本信息</div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="发货单流水号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberMobile"
                  label="会员手机号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="payMode"
                  label="支付方式"
                >
                  <template slot-scope="scope">
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'no_pay'"
                      >未支付</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === '0_pay'"
                      >0元订单</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'wx_pay'"
                      >微信支付</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'ali_pay'"
                      >支付支付</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderSource"
                  label="订单来源"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderSource === 'wxShop'"
                      >微店订单</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderType"
                  label="订单类型"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                    <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                    <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                    <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                    <span v-if="scope.row.orderType === 'smg_faceToFace'"
                      >代客下单-当面收款</span
                    >
                    <span v-if="scope.row.orderType === 'smg_netPush'"
                      >代客下单-网络推送</span
                    >
                    <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                    <span v-if="scope.row.orderType === 'integral_order'"
                      >积分兑换订单</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliveryType"
                  label="配送方式"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.deliveryType === 'mdzt'"
                      >门店自提</span
                    >
                    <span v-if="scope.row.deliveryType === 'kdfh'"
                      >快递发货</span
                    >
                    <span v-if="scope.row.deliveryType === 'tcps'"
                      >同城配送</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="detailsOrder.order.deliveryType === 'mdzt'"
                  header-align="center"
                  align="center"
                  prop="billNo"
                  label="提货单号"
                ></el-table-column>
                <el-table-column
                  v-else
                  header-align="center"
                  align="center"
                  prop="expressOrderSn"
                  label="物流单号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="自动确认收货时间"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopName"
                  label="指定信息"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderRemark"
                  label="订单备注"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="活动信息"
                ></el-table-column>
              </el-table>
            </div>
          </li>
          <li class="mb20">
            <div class="title">收货人信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverName"
                label="收货人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverMobile"
                label="手机号码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="邮政编码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliveryAddress"
                label="收货地址"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.deliveryProvince
                    }}{{ scope.row.deliveryAddress }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">商品信息</div>
            <el-table
              border
              :data="detailsOrder.orderGoods"
              size="small"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsImg"
                label="商品图片"
              >
                <template slot-scope="scope">
                  <div>
                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'yes'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                      alt=""
                    />
                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'doing'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                      alt=""
                    />

                    <img
                      style="width:100px;height:100px;"
                      v-if="scope.row.goodsImg"
                      :src="scope.row.goodsImg"
                      alt=""
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="商品名称/品牌"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.spuName }}</p>
                  <p>品牌: {{ scope.row.brandName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="价格/货号"
                width="200"
              >
                <template slot-scope="scope">
                  <p>价格: {{ scope.row.totalPrice }}</p>
                  <p>货号: {{ scope.row.goodsSn }}</p>
                  <p>条码: {{ scope.row.barCode }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="净重/毛重"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.netWeight">
                    净重: {{ scope.row.netWeight }}
                  </p>
                  <p v-if="scope.row.grossWeight">
                    毛重: {{ scope.row.grossWeight }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="规格"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="数量"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="小计"
              >
                <template slot-scope="scope">
                  <p>
                    {{ scope.row.totalPrice * scope.row.goodsNum }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">费用信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="商品合计"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.totalPrice }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliverMoney"
                label="运费"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.deliverMoney }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="couponMoney"
                label="优惠券"
                width="220"
              >
                <template slot-scope="scope">
                  <div
                    class="primary"
                    v-for="(v, i) in scope.row.orderCouponInfoModels"
                    :key="i"
                  >
                    {{ v.ruleName }} {{ v.couponCode }}
                  </div>
                  <div class="status primary">
                    -￥{{ scope.row.couponMoney }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activeMoney"
                label="积分抵扣"
                v-if="detailsOrder.order.orderType === 'integral_order'"
              >
                <template slot-scope="scope">
                  <span class="status danger"
                    >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activeMoney"
                label="活动优惠"
                v-else
              >
                <template slot-scope="scope">
                  <span class="status danger"
                    >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="actuallyPrice"
                label="实付金额"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.orderType === 'integral_order'"
                    class="status danger"
                  >
                    <span v-if="scope.row.actuallyPrice"
                      >¥{{ scope.row.actuallyPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                    >¥{{ scope.row.actuallyPrice }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payPrice"
                label="应付金额"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.orderType === 'integral_order'"
                    class="status danger"
                  >
                    <span v-if="scope.row.payPrice"
                      >¥{{ scope.row.payPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                    >¥{{ scope.row.payPrice }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogDetails = false" size="small" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import VueBarcode from "@chenfengyuan/vue-barcode";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {
    VueBarcode
  },
  mixins: [outPutMixin],
  data() {
    return {
      orderList: [
        {
          order: {
            deliveryType: "",
            receiptSn: ""
          },
          orderStatus: [
            {
              orderStatus: ""
            }
          ]
        }
      ],
      barcode_option: {
        displayValue: true,
        height: "50px"
      },
      barcode_options: {
        displayValue: true,
        height: "50px"
      },
      searchCondition: {
        timeStatus: "daipeihuo"
      },
      isDeliverSn: "",
      noNum: 0,
      yesNum: 0,
      dialogVisible: false,
      dialogVisibles: true,
      isKuaiDiDan: false,
      yunPrint: false,
      show: false,
      isShow: false,
      isShowFaHuo: false,
      dialogDetails: false,
      orderSta: "",
      checkedRow: [],
      batchCondition: {},
      receiptSn: "",
      deliverSn: "",
      expressOrderSn: "",
      isFahuodan: "0",
      orderRow: {},
      currentPage: 1,
      pageSize: 10,
      num: 0,
      daYing: {},
      stadus: true
    };
  },
  created() {
    this.$store.dispatch("expressShopList");
    // this.$store.dispatch("queryMicroStoreList");
    this.getParamsCookie();
    this.queryList();
  },

  computed: mapGetters([
    "invoiceList",
    "salesChannels",
    "allMallGoodsList",
    "shopModelList",
    "microShopStoreList",
    "detailsOrder",
    "newDetailsOrder",
    "expressShopList",
    "querySupplier"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    details(row) {
      this.dialogDetails = true;
      return this.$store
        .dispatch("detailOrder", {
          orderId: row.orderId
        })
        .then(res => {
          // let orderSta =
          //   res.result.orderStatus[res.result.orderStatus.length - 1];
          let flag = false;
          res.result.orderGoods.map(v => {
            if (v.returnType === "no") {
              flag = true;
            }
          });
          if (flag) {
            let listStatus = [];
            res.result.orderStatus.forEach(v => {
              if (v.orderStatus !== "returnOrder") {
                listStatus.push(v);
              }
            });
            // orderSta = listStatus[listStatus.length - 1];
          }

          // if (orderSta.orderStatus === "createOrder") {
          //   this.active = 1;
          //   this.delOrder = true;
          //   this.disabled = true;
          //   this.delivery = true;
          //   this.orderSta = "待付款";
          // } else if (orderSta.orderStatus === "payOrder") {
          //   this.active = 2;
          //   this.delOrder = true;
          //   this.disabled = false;
          //   this.delivery = true;
          //   this.orderSta = "待发货";
          // } else if (orderSta.orderStatus === "deliverOrder") {
          //   this.active = 3;
          //   this.delOrder = true;
          //   this.orderSta = "已发货";
          //   this.delivery = false;
          //   this.disabled = true;
          // } else if (orderSta.orderStatus === "takeOrder") {
          //   this.active = 4;
          //   this.delOrder = true;
          //   this.orderSta = "已收货";
          //   this.delivery = true;
          //   this.disabled = true;
          // } else if (orderSta.orderStatus === "pushOrder") {
          //   this.active = 5;
          //   this.delOrder = true;
          //   this.orderSta = "已评价";
          //   this.delivery = true;
          //   this.disabled = true;
          // } else if (orderSta.orderStatus === "delOrder") {
          //   this.delOrder = false;
          //   this.orderSta = "已取消";
          // } else if (orderSta.orderStatus === "returnOrder") {
          //   this.delOrder = false;
          //   this.orderSta = "有退货退款";
          // }

          res.result.orderStatus.forEach(v => {
            if (v.orderStatus === "createOrder") {
              this.createOrderTime = v.createTime;
            }
            if (v.orderStatus === "payOrder") {
              this.payOrderTime = v.createTime;
            }
            if (v.orderStatus === "deliverOrder") {
              this.deliverOrderTime = v.createTime;
            }
            if (v.orderStatus === "takeOrder") {
              this.takeOrderTime = v.createTime;
            }
            if (v.orderStatus === "pushOrder") {
              this.pushOrderTime = v.createTime;
            }
          });
        });
    },
    tableRowClassName({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },
    addGoods() {
      this.$router.push({ name: "AddMicroShopGoods" });
    },
    printInvoice(row) {
      this.$store.dispatch("querySupplier", {
        storeCode: row.storeCode
      });
      const rowOrder = JSON.parse(JSON.stringify(row));
      if (rowOrder.deliveryType === "kdfh") {
        rowOrder.deliverSn = rowOrder.receiptSn.slice(2);
      } else {
        rowOrder.deliverSn = rowOrder.billNo;
      }
      this.daYing = [rowOrder];
      this.dialogVisible = true;
      this.$store.dispatch("newDetailOrder", {
        orderId: row.orderId
      });
    },
    printCourierReceipt(row) {
      let params = [row];
      this.$store.dispatch("orderPrint", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    print() {},
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    handleClose(done) {
      done();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    switchTab() {
      this.currentPage = 1;
      this.$refs.brandTable.clearSelection();
      this.checkedRow = [];
      this.queryList();
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      this.searchCondition.printType = "";
      this.searchCondition.isSend = "";
      if (this.searchCondition.timeStatus === "daipeihuo") {
        this.searchCondition.printType = "no";
      } else if (this.searchCondition.timeStatus === "daifahuo") {
        this.searchCondition.printType = "yes";
        this.searchCondition.isSend = "no";
      } else if (this.searchCondition.timeStatus === "yifahuo") {
        this.searchCondition.printType = "yes";
        this.searchCondition.isSend = "yes";
      }

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllInvoiceList", params);
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.printType = "";
      searchCondition.isSend = "";
      if (searchCondition.timeStatus === "daipeihuo") {
        searchCondition.printType = "no";
      } else if (searchCondition.timeStatus === "daifahuo") {
        searchCondition.printType = "yes";
        searchCondition.isSend = "no";
      } else if (searchCondition.timeStatus === "yifahuo") {
        searchCondition.printType = "yes";
        searchCondition.isSend = "yes";
      }

      Object.assign(params, searchCondition);
      this.setParamsCookie();
      return this.$store.dispatch("queryInvoiceList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "InvoiceListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "InvoiceListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.daYing = selection;
      // this.checkedRow = selection.map(v => v.orderId);
      if (selection.length > 0) {
        // this.invoiceList.order.records.forEach(v => {
        //   selection.map(x => {
        //     if (v.orderId === x.orderId) {
        //       v.disabled = false;
        //     }
        //   });
        // });
        this.show = true;
        this.checkedRow = selection;
        this.daYing = JSON.parse(JSON.stringify(selection));
      } else {
        this.invoiceList.order.records.forEach(v => {
          v.disabled = true;
        });
        this.show = false;
      }

      this.num = selection.length;
    },
    scan(row) {
      if (row.disabled) {
        row.disabled = false;
      } else {
        let params = [row];
        this.$store.dispatch("batchOrderRecord", params).then(res => {
          if (res.code === "0") {
            this.queryList();
          }
        });
      }
      this.$forceUpdate();
    },
    printTe() {
      this.$print(this.$refs.print);
      this.$store.dispatch("batchOrderRecord", this.daYing).then(res => {
        if (res.code === "0") {
          this.queryList();
        }
      });
    },
    // shengCheng(row) {
    // },
    batchScan() {
      if (this.checkedRow.length) {
        // this.dialogVisible = true;
        // this.invoiceList.order.records.forEach(v => {
        //   this.checkedRow.map(x => {
        //     if (v.orderId === x.orderId) {
        //       v.disabled = false;
        //     }
        //   });
        // });
        // this.$forceUpdate();
        this.$store
          .dispatch("batchOrderRecord", this.invoiceList.order.records)
          .then(res => {
            if (res.code === "0") {
              this.queryList();
            }
          });

        this.show = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchFaHuoDan() {
      if (this.checkedRow.length) {
        let show = false;
        let dingDan = [];
        this.$store.dispatch("querySupplier", {
          storeCode: this.checkedRow[0].storeCode
        });
        this.checkedRow.map(v => {
          if (v.deliverSn) {
            show = true;
            dingDan.push(v.receiptSn);
          }
        });
        if (show) {
          this.$message({
            message: "选择项中有已打印过发货单的订单!订单号为" + dingDan,
            type: "warning"
          });
        } else {
          this.daYing.forEach(v => {
            if (v.deliveryType === "kdfh") {
              v.deliverSn = v.receiptSn.slice(2);
            } else {
              v.deliverSn = v.billNo;
            }
          });
          this.$store
            .dispatch("batchPrintOrderList", this.checkedRow)
            .then(res => {
              if (res.code === "0") {
                this.orderList = res.result;
                this.isShow = true;
              }
            });
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchSetting() {
      if (this.checkedRow.length) {
        // this.dialogVisible = true;
        let show = false;
        let dingDan = [];
        this.checkedRow.map(v => {
          if (v.expressOrderSn) {
            show = true;
            dingDan.push(v.receiptSn);
          }
        });
        if (show) {
          this.$message({
            message: "选择项中有已打印过快递单的订单!订单号为" + dingDan,
            type: "warning"
          });
        } else {
          this.$store.dispatch("orderPrint", this.checkedRow).then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    submit() {
      this.queryAllList().then(res => {
        let falg = false;
        res.result.order.records.map(v => {
          if (
            v.deliverSn === this.isDeliverSn ||
            v.expressOrderSn === this.isDeliverSn
          ) {
            falg = true;
            if (v.printType === "yes") {
              let params = [v];
              params[0].still = false;
              this.$store.dispatch("expressPut", params).then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "发货成功!",
                    type: "success"
                  });
                  this.noNum = this.noNum - 1;
                  this.yesNum = this.yesNum + 1;
                  this.isDeliverSn = "";
                  this.queryList();
                  if (this.noNum === 0) {
                    this.isShowFaHuo = false;
                    this.searchCondition.timeStatus = "daifahuo";
                    this.queryList();
                  }
                }
              });
            } else {
              this.orderRow = v;
              this.isKuaiDiDan = true;
              this.$nextTick(() => {
                this.$refs.express.focus();
              });
            }
          }
        });
        if (!falg) {
          this.$message({
            message: "发货失败,无匹配订单！",
            type: "warning"
          });
        }
      });
    },
    submitExpress() {
      if (this.expressOrderSn) {
        this.orderRow.expressOrderSn = this.expressOrderSn.trim();
        let params = [this.orderRow];
        params[0].still = false;
        this.$store.dispatch("batchOrderRecord", params).then(res => {
          if (res.code === "0") {
            this.$store.dispatch("expressPut", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "发货成功!",
                  type: "success"
                });
                this.isKuaiDiDan = false;
                this.$nextTick(() => {
                  this.$refs.deliverSn.focus();
                });
                this.noNum = this.noNum - 1;
                this.yesNum = this.yesNum + 1;
                this.isDeliverSn = "";
                this.expressOrderSn = "";
                this.queryList();
                if (this.noNum === 0) {
                  this.isShowFaHuo = false;
                  this.searchCondition.timeStatus = "daifahuo";
                  this.queryList();
                }
              }
            });
          }
        });
      } else {
        this.$message({
          message: "请填写快递单号！",
          type: "warning"
        });
      }
    },
    submitOrderSn(row) {
      if (row.disabled) {
        row.disabled = false;
      } else {
        let params = [row];
        this.$store.dispatch("batchOrderRecord", params).then(res => {
          if (res.code === "0") {
            this.queryList();
          }
        });
      }
      this.$forceUpdate();
    },
    tingZhi() {
      this.isShowFaHuo = false;
      this.searchCondition.timeStatus = "daifahuo";
      this.queryList();
    },
    batchFaHuo() {
      // if (this.checkedRow.length) {
      //   this.isShowFaHuo = true;
      //   this.noNum = this.checkedRow.length;
      // } else {
      //   this.$message({
      //     message: "请选择",
      //     type: "warning"
      //   });
      // }
      this.isShowFaHuo = true;
      this.$nextTick(() => {
        this.$refs.deliverSn.focus();
      });
      this.noNum = this.invoiceList.number.no_express;
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res.result.order.records;
            list.forEach(v => {
              if (v.deliveryType === "mdzt") {
                v.deliveryType = "门店自提";
              } else if (v.deliveryType === "kdfh") {
                v.deliveryType = "快递发货";
              } else if (v.deliveryType === "tcps") {
                v.deliveryType = "同城配送";
              }
            });

            const tHeader = [
              "订单号",
              "配送方式",
              "发货人",
              "发货人电话",
              "发件地区",
              "发件详细地址",
              "收货人",
              "收货人电话",
              "收件地区",
              "收件详细地址"
            ];
            const filterVal = [
              "receiptSn",
              "deliveryType",
              "shopName",
              "bzd",
              "bzd",
              "bzd",
              "bzd",
              "receiverName",
              "receiverMobile",
              "deliveryProvince",
              "deliveryAddress"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "发货单列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    }
  }
};
</script>

<style lang="scss">
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}
.table-body .warning-tuikuan {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 0;
  top: 0;
}
.tuikuan {
  background: rgba(255, 240, 240, 1);
  // border: 1px solid rgba(255, 0, 0, 1);
  position: relative;
  z-index: 9999999;
}
.mb30 {
  margin-bottom: 30px;
}
.wrongs {
  background: rgba(255, 240, 240, 1);
  border: 1px solid rgba(255, 0, 0, 1);
}
.content {
  .el-step.is-center .el-step__description {
    padding: 0;
  }
}
#printTest {
  .el-table {
    border: 1px solid #ebeef5;
  }
}
</style>
<style scoped lang="scss">
.fz {
  font-size: 12px;
}
.mb5 {
  margin-bottom: 5px;
}
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}
// #printTest {
//   border: 1px solid #ebeef5;
// }
.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}

.content {
  margin: -10px -20px -20px -20px;
  .progress {
    background: #f7f7f7;
    padding: 20px 0;
  }
}
.info-list {
  padding: 0 20px;
  .tit {
    padding: 20px;
    border-bottom: 5px solid #000000;
  }
  .hr {
    width: 1px;
    height: 92px;
    background-color: #b7b7b7;
  }
  .logoImg {
    width: 92px;
    height: 92px;
    padding-right: 20px;

    img {
      width: 100px;
      height: 100px;
    }
  }
  .sh-info {
    padding-left: 10px;
    border-left: 2px solid #b7b7b7;
    .sh-name {
      font-size: 20px;
      font-weight: 600;
    }
    .sh-xinxi {
      line-height: 24px;
    }
  }
  .consignee {
    border-bottom: 2px solid #b7b7b7;
    padding: 20px 0;
    div {
      line-height: 24px;
    }
  }
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: rgb(96, 98, 102);
      line-height: 23px;
      font-size: 12px;
      font-weight: 700;
    }
  }
  .table-body {
    padding: 15px;
    border-bottom: 1px solid #ddd;
    > div {
      white-space: normal;
      word-break: break-all;
      line-height: 23px;
      font-size: 12px;
    }
  }
}
.content-item {
  line-height: 25px;
  color: #222;
  .info {
    color: #666666;
  }
}
</style>
